export default {"src":"/_next/static/media/phone.f12fb1a0.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};